import React from 'react';
import PropTypes from 'prop-types';


const PageNumberInfo = ({ currentPage, totalPages, loading }) => (
  <h3 className="fw-medium m-b-5" disabled={loading}>
    Showing page {currentPage} of {totalPages}
  </h3>
);

PageNumberInfo.propTypes = {
  currentPage: PropTypes.string.isRequired,
  totalPages: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default PageNumberInfo;



// WEBPACK FOOTER //
// ./library/app/components/Global/Pager/PageNumberInfo.js